module.exports = __webpack_public_path__ + "media/spence/spence_icon-bdea08e3.svg";